(function () {
  'use strict';
  var tr=function(key,fallback){var i18n=window.NNOMRewardsI18n;return i18n?i18n.t(key,fallback):fallback;};
  var displayLocale=(window.NNOMRewardsI18n&&window.NNOMRewardsI18n.locale)||'vi-VN';


  var config = window.NNOMRewardsConfig || {};
  if (!config.enabled) return;

  var referralStorageKey = 'nnom_rewards_referral_v1';
  var referralSyncKey = 'nnom_rewards_referral_synced_v1';
  var hydrateTimer = null;
  var walletPromise = null;

  function endpoint(path) {
    var base = String(config.appProxyPath || '/apps/rewards').replace(/\/$/, '');
    return base + path;
  }

  function cartUpdateUrl() {
    var route = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return route.replace(/\.js$/, '') + '.js';
  }

  function cartStateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function safeCode(value) {
    value = String(value || '').trim();
    return /^[A-Za-z0-9_-]{2,64}$/.test(value) ? value : '';
  }

  function parseJson(response) {
    return response.json().catch(function () { return {}; }).then(function (data) {
      if (!response.ok) {
        var error = new Error(data.message || data.error || tr('khong_the_ket_noi_he_thong_diem_6b5e48e5',"Không thể kết nối hệ thống điểm."));
        error.status = response.status;
        throw error;
      }
      return data;
    });
  }

  function request(path, options) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
    var requestOptions = Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller.signal
    }, options || {});

    return fetch(endpoint(path), requestOptions)
      .then(parseJson)
      .finally(function () { window.clearTimeout(timeout); });
  }

  function formatPoints(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) number = 0;
    return new Intl.NumberFormat(displayLocale, { maximumFractionDigits: 2 }).format(number);
  }

  function sampleAmount(earning) {
    var value = Number(earning && earning.sampleAmountVnd);
    return Number.isFinite(value) && value > 0 ? value : 1000000;
  }

  function earnPercentText(tier, earning) {
    var baseBps = Number(earning && earning.baseRateBps);
    var bonusBps = Number(tier && tier.earnBonusBps);
    if (!Number.isFinite(baseBps) || !Number.isFinite(bonusBps)) return '—';
    var percent = new Intl.NumberFormat(displayLocale, { maximumFractionDigits: 2 }).format((Math.max(0, baseBps) + Math.max(0, bonusBps)) / 100) + '%';
    return tr('xu_cong_them_theo_hang_45df1a5e',"Phần trăm tích Xu theo từng hóa đơn") + ': ' + percent;
  }

  function setStatus(scope, message, tone) {
    var target = scope && scope.querySelector('[data-nnom-rewards-status]');
    if (!target) return;
    target.textContent = message || '';
    if (tone) target.dataset.tone = tone;
    else target.removeAttribute('data-tone');
  }

  function setButtonBusy(button, busy) {
    if (!button) return;
    button.disabled = Boolean(busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function fallbackWallet(scope) {
    if (!scope || scope.dataset.fallbackReady !== 'true') return null;
    return {
      balances: {
        lp: {
          available: scope.dataset.lpAvailable || 0,
          pending: scope.dataset.lpPending || 0
        }
      },
      referral: { code: scope.dataset.referralCode || '' },
      transactions: []
    };
  }

  function normalizeWallet(data) {
    data = data || {};
    // The production App Proxy returns { wallet, referral, history }. Keep the
    // portal resilient to the former { balances, transactions } response too.
    var source = data.wallet || data;
    var balances = source.balances || source;
    return {
      balances: {
        lp: balances.lp || {}
      },
      referral: data.referral || source.referral || {},
      conversion: data.conversion || source.conversion || {},
      voucherPolicy: data.voucherPolicy || { allowMultiple: false },
      tier: data.tier || null,
      tiers: Array.isArray(data.tiers) ? data.tiers : [],
      earning: data.earning || source.earning || {},
      vouchers: Array.isArray(data.vouchers) ? data.vouchers : [],
      voucherOffers: Array.isArray(data.voucherOffers) ? data.voucherOffers : [],
      birthday: data.birthday || null,
      nextExpiring: data.nextExpiring || null,
      transactions: Array.isArray(data.history)
        ? data.history
        : (Array.isArray(data.transactions) ? data.transactions : [])
    };
  }

  function getWallet(forceRefresh) {
    if (forceRefresh) walletPromise = null;
    if (!walletPromise) {
      walletPromise = request('/wallet')
        .then(normalizeWallet)
        .catch(function (error) {
          walletPromise = null;
          throw error;
        });
    }
    return walletPromise;
  }

  function walletValue(wallet, key) {
    var values = {
      lp_available: wallet.balances.lp.available,
      lp_pending: wallet.balances.lp.pending
    };
    return values[key] == null ? 0 : values[key];
  }

  function renderBalances(scope, wallet) {
    scope.querySelectorAll('[data-rewards-value]').forEach(function (node) {
      node.textContent = formatPoints(walletValue(wallet, node.dataset.rewardsValue));
    });
  }

  function transactionLabel(transaction) {
    return transaction.note || transaction.description || transaction.eventType || transaction.order_name || transaction.reference || tr('giao_dich_diem_d5aab503',"Giao dịch điểm");
  }

  function renderTransactions(scope, transactions) {
    var wrap = scope.querySelector('[data-nnom-rewards-transactions]');
    var body = scope.querySelector('[data-nnom-rewards-transaction-body]');
    var empty = scope.querySelector('[data-nnom-rewards-empty]');
    if (!wrap || !body || !empty) return;

    body.textContent = '';
    if (!transactions.length) {
      wrap.hidden = true;
      empty.hidden = false;
      return;
    }

    transactions.forEach(function (transaction) {
      var row = document.createElement('tr');
      var createdAt = transaction.createdAt || transaction.created_at;
      var date = createdAt ? new Date(createdAt) : null;
      var cells = [
        date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString(displayLocale) : '',
        transactionLabel(transaction),
        String(transaction.pointType || transaction.point_type || '').toUpperCase() === 'LP' ? 'Prima Xu' : String(transaction.pointType || transaction.point_type || '').toUpperCase(),
        transaction.status || transaction.bucket || '',
        formatPoints(transaction.amount)
      ];

      cells.forEach(function (value, index) {
        var cell = document.createElement('td');
        cell.textContent = value;
        if (index === 4) cell.dataset.align = 'right';
        row.appendChild(cell);
      });
      body.appendChild(row);
    });

    wrap.hidden = false;
    empty.hidden = true;
  }

  function selectedDepot() {
    var select = document.querySelector('[data-nnom-rewards-depot]');
    return select ? safeCode(select.value) : '';
  }

  function buildInvite(scope, wallet) {
    var input = scope.querySelector('[data-nnom-rewards-invite]');
    if (!input) return;

    if (wallet.referral.url) {
      input.value = wallet.referral.url;
      return;
    }

    var code = safeCode(wallet.referral.code || scope.dataset.referralCode);
    if (!code) {
      input.value = '';
      input.placeholder = tr('ma_gioi_thieu_chua_duoc_cap_a7684c8f',"Mã giới thiệu chưa được cấp");
      return;
    }

    var url = new URL(config.inviteLandingPath || '/', window.location.origin);
    url.searchParams.set('ref', code);
    var depot = safeCode(wallet.referral.depot_id || selectedDepot());
    if (depot) url.searchParams.set('depot', depot);
    input.value = url.toString();
  }

  function voucherValue(item) {
    if (item.discountType === 'FREE_SHIPPING') return tr('mien_phi_van_chuyen_5fd8a314',"Miễn phí vận chuyển");
    if (item.discountType === 'PERCENTAGE') return new Intl.NumberFormat(displayLocale, { maximumFractionDigits: 2 }).format(Number(item.percentageBps || 0) / 100) + '%';
    return formatMoney(item.amountVnd);
  }

  function voucherTicket(item, action, isOffer) {
    var card = document.createElement('article');
    card.className = 'nnom-voucher-ticket';
    if (item.discountType === 'FREE_SHIPPING') card.classList.add('nnom-voucher-ticket--shipping');
    if (item.discountType === 'PERCENTAGE') card.classList.add('nnom-voucher-ticket--percentage');
    var value = document.createElement('div');
    value.className = 'nnom-voucher-ticket__value';
    var caption = document.createElement('span');
    caption.textContent = item.discountType === 'FREE_SHIPPING' ? tr('uu_dai_150a013e',"Ưu đãi") : tr('giam_a6c2901a',"Giảm");
    var amount = document.createElement('strong');
    amount.textContent = voucherValue(item);
    value.append(caption, amount);
    /* Ticket icon adapted from https://uiverse.io/Javierrocadev/curly-wolverine-36
     * MIT License — Copyright (c) 2026 Javierrocadev (Javier Roca)
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
     * of the Software, and to permit persons to whom the Software is furnished to
     * do so, subject to the following conditions:
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 100 100');
    icon.setAttribute('aria-hidden', 'true');
    icon.classList.add('nnom-voucher-ticket__icon');
    var outline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    outline.setAttribute('d', 'M60.7,25v7.2m0,14.2v7.2m0,14.2V75M25,25a7.1,7.1,0,0,0-7.1,7.2V42.9a7.1,7.1,0,1,1,0,14.2V67.8A7.1,7.1,0,0,0,25,75H75a7.1,7.1,0,0,0,7.1-7.2V57.1a7.1,7.1,0,1,1,0-14.2V32.2A7.1,7.1,0,0,0,75,25Z');
    if (item.discountType === 'FREE_SHIPPING') {
      outline.setAttribute('d', 'M15 30h44v39H15zM59 44h15l12 14v11H59M27 69a8 8 0 1 0 16 0a8 8 0 1 0-16 0M64 69a8 8 0 1 0 16 0a8 8 0 1 0-16 0M21 42h23M21 51h15');
    }
    icon.appendChild(outline);
    var heading = document.createElement('div');
    heading.className = 'nnom-voucher-ticket__heading';
    heading.append(value, icon);
    var info = document.createElement('div');
    info.className = 'nnom-voucher-ticket__info';
    var title = document.createElement('strong');
    title.textContent = item.displayTitle || item.title || (item.kind === 'BIRTHDAY' ? tr('qua_sinh_nhat_01f4dd9e',"Quà sinh nhật") : tr('uu_dai_thanh_vien_815d8d82',"Ưu đãi thành viên"));
    info.appendChild(title);
    var description = item.displayDescription || item.description;
    if (description) {
      var detail = document.createElement('span');
      detail.textContent = description;
      info.appendChild(detail);
    }
    var conditions = [];
    if (Number(item.minimumSubtotalVnd) > 0) conditions.push(tr('don_tu_db5eb99e',"Đơn từ ") + formatMoney(item.minimumSubtotalVnd));
    var labels = { PRODUCT: tr('san_pham_48f85a5f',"Sản phẩm"), COLLECTION: tr('bo_suu_tap_5507a578',"Bộ sưu tập"), TAG: tr('nhom_san_pham_513df839',"Nhóm sản phẩm") };
    conditions.push(labels[item.appliesToType] ? labels[item.appliesToType] + ': ' + (item.appliesToLabel || tr('duoc_chon_d1824a7a',"được chọn")) : tr('toan_bo_don_hang_929555e2',"Toàn bộ đơn hàng"));
    var validity = document.createElement('span');
    validity.className = 'nnom-voucher-ticket__validity';
    if (isOffer) validity.textContent = tr('dung_trong_9eab8724',"Dùng trong ") + item.validityDays + tr('ngay_sau_khi_doi_4ccc57be'," ngày sau khi đổi");
    else if (item.expiresAt) {
      var expires = new Date(item.expiresAt);
      if (!Number.isNaN(expires.getTime())) validity.textContent = tr('het_han_a45e2ce1',"Hết hạn ") + expires.toLocaleDateString(displayLocale);
    }
    var meta = document.createElement('span');
    meta.className = 'nnom-voucher-ticket__conditions';
    meta.textContent = conditions.join(' · ');
    info.appendChild(meta);
    action.classList.add('nnom-voucher-ticket__action');
    var footer = document.createElement('div');
    footer.className = 'nnom-voucher-ticket__footer';
    footer.append(validity, action);
    card.append(heading, info, footer);
    return card;
  }

  function tierJourney(wallet) {
    var tier = wallet.tier || {};
    var milestones = (wallet.tiers || []).slice().sort(function (left, right) {
      return Number(left.rank) - Number(right.rank);
    });
    var earned = Number(tier.qualifiedXu);
    earned = Number.isFinite(earned) ? Math.max(0, earned) : 0;
    var target = milestones.reduce(function (highest, item) {
      return Math.max(highest, Number(item.thresholdXu) || 0);
    }, Math.max(0, Number(tier.nextThresholdXu) || 0));
    return {
      milestones: milestones,
      earned: earned,
      target: target,
      percent: target > 0 ? Math.min(100, earned / target * 100) : milestones.length ? 100 : 0,
      current: milestones.find(function (item) { return item.id === tier.id; }) || null,
      next: milestones.find(function (item) { return Number(item.rank) > Number(tier.rank || 0); }) || null
    };
  }

  function renderMemberBenefits(scope, wallet) {
    if (!scope) return;
    var tier = wallet.tier || {};
    var tierName = scope.querySelector('[data-nnom-tier-name]');
    var earnRate = scope.querySelector('[data-nnom-tier-earn-rate]');
    var qualified = scope.querySelector('[data-nnom-tier-qualified]');
    var next = scope.querySelector('[data-nnom-tier-next]');
    var progress = scope.querySelector('[data-nnom-tier-progress]');
    var progressFill = scope.querySelector('[data-nnom-tier-progress-fill]');
    var levels = scope.querySelector('[data-nnom-tier-levels]');
    var vouchers = scope.querySelector('[data-nnom-benefit-vouchers]');
    var expiry = scope.querySelector('[data-nnom-expiry-note]');
    if (tierName) tierName.textContent = tier.name || 'Member';
    var journey = tierJourney(wallet);
    var currentTier = journey.current || tier;
    var earning = Object.assign({}, wallet.earning);
    earning.lpValueVnd = Number(wallet.earning && wallet.earning.lpValueVnd) || Number(wallet.conversion && wallet.conversion.lpValueVnd) || 0;
    if (Number.isFinite(Number(wallet.earning && wallet.earning.baseRateBps))) earning.baseRateBps = Number(wallet.earning.baseRateBps);
    else delete earning.baseRateBps;
    var amount = sampleAmount(earning);
    scope.dataset.nnomSampleAmountVnd = String(amount);
    window.NNOMRewardsEarning = earning;
    if (earnRate) earnRate.textContent = earnPercentText(currentTier, earning);
    if (window.NNOMTierVisuals) window.NNOMTierVisuals.hero(scope, tier, journey.milestones);
    // Rank qualification is lifetime earned Xu, never the spendable wallet balance.
    if (qualified) qualified.textContent = formatPoints(journey.earned);
    var current = journey.current;
    var nextTier = journey.next;
    var upper = nextTier ? Number(nextTier.thresholdXu) || 0 : Number(tier.nextThresholdXu) || 0;
    if (progress) {
      progress.setAttribute('aria-valuemax', String(journey.target || 1));
      progress.setAttribute('aria-valuenow', String(Math.min(journey.earned, journey.target)));
      progress.setAttribute('aria-valuetext', formatPoints(journey.earned) + tr('xu_da_kiem_duoc_truoc_khi_doi_voucher_hang_dan_bca121dc'," Xu đã kiếm được trước khi đổi voucher; hạng đang giữ: ") + (tier.name || 'Member'));
      progress.querySelectorAll('[data-nnom-tier-marker]').forEach(function (marker) { marker.remove(); });
      journey.milestones.forEach(function (item, index) {
        var marker = document.createElement('i');
        var threshold = Math.max(0, Number(item.thresholdXu) || 0);
        marker.className = 'nnom-rewards-tier__marker';
        marker.dataset.nnomTierMarker = '';
        marker.dataset.reached = journey.earned >= threshold ? 'true' : 'false';
        marker.dataset.current = item.id === tier.id ? 'true' : 'false';
        marker.style.left = (journey.target > 0 ? Math.min(100, threshold / journey.target * 100) : 0) + '%';
        marker.textContent = String(index + 1);
        marker.title = item.name + ' · ' + formatPoints(threshold) + ' Xu';
        marker.setAttribute('aria-hidden', 'true');
        progress.appendChild(marker);
      });
    }
    if (progressFill) progressFill.style.width = journey.percent + '%';
    if (next) next.textContent = !wallet.tiers.length
      ? tr('cua_hang_dang_cau_hinh_cac_hang_thanh_vien_2077d4de',"Cửa hàng đang cấu hình các hạng thành viên.")
      : upper > 0
        ? tr('tich_them_b9b4bf8b',"Tích thêm ") + formatPoints(Math.max(0, upper - journey.earned)) + tr('xu_de_len_5d0a36c2'," Xu để lên ") + (nextTier ? nextTier.name : tier.nextName) + tr('xu_da_doi_voucher_khong_lam_giam_tien_trinh_fca86b09',". Xu đã đổi voucher không làm giảm tiến trình.")
        : tr('ban_dang_o_hang_cao_nhat_hien_co_chuc_mung_cc5b733b',"Bạn đang ở hạng cao nhất hiện có. Chúc mừng!");
    if (expiry && wallet.nextExpiring && wallet.nextExpiring.expiresAt) {
      expiry.textContent = formatPoints(wallet.nextExpiring.remainingAmount) + tr('xu_gan_nhat_het_han_671e5e72'," Xu gần nhất hết hạn ") + new Date(wallet.nextExpiring.expiresAt).toLocaleDateString(displayLocale) + '.';
    }
    if (levels) {
      levels.textContent = '';
      var milestones = journey.milestones;
      if (!current && milestones.length) {
        var starter = document.createElement('article');
        starter.className = 'nnom-rewards-tier__level';
        starter.dataset.current = 'true';
        var starterTitle = document.createElement('strong');
        starterTitle.textContent = tier.name || 'Member';
        var starterThreshold = document.createElement('small');
        starterThreshold.textContent = tr('hang_hien_tai_301e3dc0',"Hạng hiện tại");
        starter.append(starterTitle, starterThreshold);
        levels.appendChild(starter);
      }
      levels.classList.add('nnom-rewards-tier__levels--journey');
      levels.style.setProperty('--nnom-tier-count', String(Math.max(milestones.length, 1)));
      milestones.forEach(function (item, index) {
        var card = document.createElement('article');
        card.className = 'nnom-rewards-tier__level';
        card.dataset.current = item.id === tier.id ? 'true' : 'false';
        card.dataset.milestone = item.id === tier.id ? 'current' : journey.earned >= Number(item.thresholdXu) ? 'achieved' : 'upcoming';
        var title = document.createElement('strong');
        title.textContent = String(index + 1) + ' · ' + item.name;
        var threshold = document.createElement('small');
        threshold.textContent = item.id === tier.id
          ? tr('hang_dang_giu_moc_3c5e5cda',"Hạng đang giữ · mốc ") + formatPoints(item.thresholdXu) + ' Xu'
          : tr('moc_thang_hang_tu_758acba3',"Mốc thăng hạng · từ ") + formatPoints(item.thresholdXu) + ' Xu';
        var list = document.createElement('ul');
        [
          earnPercentText(item, earning),
          item.nextOrderVoucherVnd > 0 ? 'Voucher ' + formatMoney(item.nextOrderVoucherVnd) + tr('cho_don_tiep_theo_c5957b21'," cho đơn tiếp theo") : null,
          item.birthdayXu > 0 ? tr('sinh_nhat_tang_da953063',"Sinh nhật: tặng ") + formatPoints(item.birthdayXu) + ' Xu' : null,
          item.birthdayVoucherVnd > 0 ? tr('sinh_nhat_voucher_9f104800',"Sinh nhật: voucher ") + formatMoney(item.birthdayVoucherVnd) : null
        ].filter(Boolean).forEach(function (benefit) {
          var line = document.createElement('li');
          line.textContent = benefit;
          list.appendChild(line);
        });
        card.appendChild(title);
        card.appendChild(threshold);
        card.appendChild(list);
        if (window.NNOMTierVisuals) window.NNOMTierVisuals.decorate(card, item, milestones, scope);
        levels.appendChild(card);
      });
      if (!wallet.tiers.length) levels.textContent = tr('chuong_trinh_thang_hang_dang_duoc_cua_hang_cau_92e6b0e8',"Chương trình thăng hạng đang được cửa hàng cấu hình.");
    }
    if (vouchers) {
      vouchers.textContent = '';
      wallet.vouchers.forEach(function (item) {
        var link = document.createElement('a');
        link.href = '/discount/' + encodeURIComponent(item.code) + '?redirect=/cart';
        link.textContent = tr('su_dung_c016d15c',"Sử dụng");
        vouchers.appendChild(voucherTicket(item, link, false));
      });
      if (!wallet.vouchers.length) {
        var emptyVoucher = document.createElement('p');
        emptyVoucher.className = 'nnom-rewards-note';
        emptyVoucher.textContent = tr('voucher_cua_ban_se_xuat_hien_o_day_sau_khi_duo_6e5ced60',"Voucher của bạn sẽ xuất hiện ở đây sau khi được cấp hoặc đổi Xu.");
        vouchers.appendChild(emptyVoucher);
      }
    }
    scope.dataset.nnomVoucherCount = String((wallet.vouchers || []).length);
  }

  function renderVoucherOffers(scope, wallet) {
    var list = scope && scope.querySelector('[data-nnom-voucher-offers]');
    if (!list) return;
    list.textContent = '';
    var available = Number(wallet.balances.lp.available || 0);
    (wallet.voucherOffers || []).forEach(function (offer) {
      var action = document.createElement('button');
      action.type = 'button';
      action.className = 'nnom-rewards-voucher-offer__redeem';
      action.dataset.nnomVoucherOfferRedeem = offer.id;
      action.dataset.pointsCost = String(offer.pointsCostXu);
      var soldOut = offer.remaining !== null && offer.remaining !== undefined && Number(offer.remaining) <= 0;
      action.disabled = soldOut || available < Number(offer.pointsCostXu || 0);
      action.textContent = soldOut ? tr('da_het_luot_doi_1cdee328',"Đã hết lượt đổi") : action.disabled ? formatPoints(offer.pointsCostXu) + tr('xu_chua_du_4aac332b'," Xu · Chưa đủ") : tr('doi_8f75900f',"Đổi ") + formatPoints(offer.pointsCostXu) + ' Xu';
      list.appendChild(voucherTicket(offer, action, true));
    });
    if (!(wallet.voucherOffers || []).length) {
      var empty = document.createElement('p');
      empty.className = 'nnom-rewards-note';
      empty.textContent = tr('hien_chua_co_voucher_mo_doi_cac_uu_dai_moi_se__21d70b81',"Hiện chưa có voucher mở đổi. Các ưu đãi mới sẽ xuất hiện tại đây.");
      list.appendChild(empty);
    }
  }

  function redeemVoucherOffer(button) {
    var scope = button.closest('[data-nnom-rewards-portal]');
    var status = scope && scope.querySelector('[data-nnom-voucher-offer-status]');
    if (!scope || !status || button.disabled) return;
    var offerId = button.dataset.nnomVoucherOfferRedeem;
    var initialVoucherCount = Number(scope.dataset.nnomVoucherCount || 0);
    var idempotencyKey = button.dataset.redemptionKey || (window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : 'redeem-' + Date.now() + '-' + Math.random().toString(36).slice(2));
    button.dataset.redemptionKey = idempotencyKey;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = tr('dang_giu_prima_xu_va_phat_hanh_voucher_7aa77568',"Đang giữ Prima Xu và phát hành voucher…");
    status.dataset.tone = 'info';
    request('/voucher-offers/redeem', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey },
      body: JSON.stringify({ offerId: offerId, idempotencyKey: idempotencyKey })
    }).then(function (result) {
      status.textContent = result.status === 'ACTIVE'
        ? tr('voucher_da_san_sang_trong_muc_voucher_cua_ban_cf5cd0ba',"Voucher đã sẵn sàng trong mục “Voucher của bạn”.")
        : tr('da_nhan_yeu_cau_doi_voucher_se_xuat_hien_trong_b0f2322a',"Đã nhận yêu cầu đổi. Voucher sẽ xuất hiện trong ví sau khi được phát hành.");
      status.dataset.tone = 'success';
      getWallet(true).then(function (wallet) {
        renderBalances(scope, wallet);
        renderMemberBenefits(scope, wallet);
        renderVoucherOffers(scope, wallet);
        if (wallet.vouchers.length <= initialVoucherCount && result.status !== 'ACTIVE') refreshIssuedOfferVoucher(scope, initialVoucherCount, 4);
      }).catch(function () {});
    }).catch(function (error) {
      status.textContent = error && error.message ? error.message : tr('chua_doi_duoc_voucher_vui_long_thu_lai_sau_a1bab269',"Chưa đổi được voucher. Vui lòng thử lại sau.");
      button.disabled = false;
      status.dataset.tone = 'error';
    }).finally(function () {
      button.removeAttribute('aria-busy');
    });
  }

  function refreshIssuedOfferVoucher(scope, initialCount, attemptsLeft) {
    if (!attemptsLeft) return;
    window.setTimeout(function () {
      getWallet(true).then(function (wallet) {
        renderBalances(scope, wallet);
        renderMemberBenefits(scope, wallet);
        renderVoucherOffers(scope, wallet);
        if (wallet.vouchers.length > initialCount) {
          var status = scope.querySelector('[data-nnom-voucher-offer-status]');
          if (status) { status.textContent = tr('voucher_da_san_sang_trong_muc_voucher_cua_ban_cf5cd0ba',"Voucher đã sẵn sàng trong mục “Voucher của bạn”."); status.dataset.tone = 'success'; }
          return;
        }
        refreshIssuedOfferVoucher(scope, initialCount, attemptsLeft - 1);
      }).catch(function () { refreshIssuedOfferVoucher(scope, initialCount, attemptsLeft - 1); });
    }, 2500);
  }

  function hydrateScope(scope) {
    if (!scope || scope.dataset.customerAuthenticated !== 'true') return;
    if (scope.dataset.rewardsHydrated === 'true') return;
    if (scope.dataset.rewardsHydrating === 'true') return;
    scope.dataset.rewardsHydrating = 'true';
    if (window.PrimaSkeleton) window.PrimaSkeleton.setLoading(scope, true);

    getWallet()
      .then(function (wallet) {
        renderBalances(scope, wallet);
        renderTransactions(scope, wallet.transactions);
        renderMemberBenefits(scope, wallet);
        renderVoucherOffers(scope, wallet);
        buildInvite(scope, wallet);
        scope.dataset.voucherMaxLp = String(Number(wallet.balances.lp.available || 0));
        scope.dataset.lpValueVnd = String(Number(wallet.conversion.lpValueVnd || 0));
        var voucherInput = scope.querySelector('[data-nnom-rewards-voucher] [name="requestedLp"]');
        var voucherHelp = scope.querySelector('[data-nnom-rewards-voucher-help]');
        var lpValue = Number(scope.dataset.lpValueVnd || 0);
        if (voucherInput) {
          voucherInput.min = '1';
          voucherInput.step = '1';
          voucherInput.max = scope.dataset.voucherMaxLp;
          voucherInput.placeholder = '1';
        }
        if (voucherHelp && lpValue > 0) {
          voucherHelp.textContent = tr('ban_co_a540c274',"Bạn có ") + formatPoints(wallet.balances.lp.available || 0) + tr('prima_xu_moi_xu_doi_duoc_fc7fdeb8'," Prima Xu. Mỗi Xu đổi được ") + lpValue.toLocaleString(displayLocale) + tr('d_789721c8',"đ.");
        }
        setStatus(scope, '', 'success');
      })
      .catch(function (error) {
        var fallback = fallbackWallet(scope);
        if (fallback) {
          renderBalances(scope, normalizeWallet(fallback));
          buildInvite(scope, normalizeWallet(fallback));
          setStatus(scope, tr('dang_hien_thi_so_du_gan_nhat_vi_diem_tam_thoi__0cec07e1',"Đang hiển thị số dư gần nhất; ví điểm tạm thời chưa kết nối."), 'warning');
        } else {
          var message = error && error.status === 401
            ? tr('phien_dang_nhap_da_het_han_vui_long_dang_nhap__50572ac9',"Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại để xem ví điểm.")
            : error && error.status === 503
              ? tr('vi_diem_dang_duoc_cap_nhat_ban_co_the_quay_lai_70397085',"Ví điểm đang được cập nhật. Bạn có thể quay lại sau ít phút.")
              : tr('hien_chua_the_tai_vi_diem_ban_co_the_quay_lai__e8431b01',"Hiện chưa thể tải ví điểm. Bạn có thể quay lại sau ít phút.");
          setStatus(scope, message, 'error');
        }
      })
      .finally(function () {
        scope.dataset.rewardsHydrating = 'false';
        scope.dataset.rewardsHydrated = 'true';
        if (window.PrimaSkeleton) window.PrimaSkeleton.setLoading(scope, false);
      });
  }

  function hydrateAll() {
    document.querySelectorAll('[data-nnom-rewards-cart], [data-nnom-rewards-portal]').forEach(hydrateScope);
    document.querySelectorAll('[data-nnom-cart-rewards]').forEach(hydrateCartRewards);
  }

  function scheduleHydrate() {
    window.clearTimeout(hydrateTimer);
    hydrateTimer = window.setTimeout(hydrateAll, 80);
  }

  function updateCartAttributes(attributes) {
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-NNOM-Attributes-Only': '1'
      },
      body: JSON.stringify({ attributes: attributes })
    }).then(parseJson);
  }

  function updateCartDiscountCodes(codes, signal, attributes) {
    var normalized = uniqueCartDiscountCodes(codes),drawer = document.querySelector('cart-drawer');
    var payload = {discount:normalized.join(',')};
    if (attributes) payload.attributes = attributes;
    var revision;
    if (drawer) {
      drawer._nnomCartRevision = (drawer._nnomCartRevision || 0) + 1; revision = drawer._nnomCartRevision;
      payload.sections = ['cart-drawer','cart-icon-bubble']; payload.sections_url = window.location.pathname;
    }
    return fetch(cartUpdateUrl(), {
      method:'POST',credentials:'same-origin',signal:signal,
      headers:{Accept:'application/json','Content-Type':'application/json','X-NNOM-Rewards-Cart':'1'},
      body:JSON.stringify(payload)
    }).then(parseJson).then(function (cart) { cart._nnomRewardsRevision = revision; return cart; });
  }

  // Manual Shopify codes remain separate from rewards and referral attribution.
  var manualDiscountBusy = false;
  var manualDiscountNotice = null;
  function cleanCartDiscountCode(value) {
    var code = String(value || '').trim();
    return code && code.length <= 255 && !/[,\u0000-\u001f\u007f]/.test(code) ? code : '';
  }
  function uniqueCartDiscountCodes(codes) {
    return (codes || []).map(cleanCartDiscountCode).filter(function (code,index,list) {
      return code && list.findIndex(function (item) { return item.toUpperCase() === code.toUpperCase(); }) === index;
    });
  }
  function cartPromoEntries(cart) {
    return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : []).filter(function (entry) { return entry && typeof entry.code === 'string' && cleanCartDiscountCode(entry.code); });
  }
  function manualCartPromoEntries(scope,cart) {
    var attributes = cart && cart.attributes || {};
    var selected = readSelectedVoucherCodes(attributes['NNOM Selected Vouchers'] || attributes['NNOM Selected Voucher'] || scope.dataset.selectedVouchers || scope.dataset.selectedVoucher);
    var managed = selected.concat(attributes['NNOM Referral Discount'] || '').map(function (code) { return String(code).toUpperCase(); });
    return cartPromoEntries(cart).filter(function (entry) { return !managed.includes(entry.code.toUpperCase()); });
  }
  function cartDiscountMessage(scope,key) {
    var node = scope.querySelector('[data-nnom-discount-messages]') || document.querySelector('[data-nnom-discount-messages]');
    try { return JSON.parse(node.textContent)[key] || ''; } catch (error) { return ''; }
  }
  function setCartDiscountStatus(scope,key,tone) {
    var status = scope && scope.querySelector('[data-nnom-discount-status],[data-nnom-cart-rewards-status]');
    if (!status) return;
    status.textContent = cartDiscountMessage(scope,key);
    if (tone) status.dataset.tone = tone; else status.removeAttribute('data-tone');
    var input = scope.querySelector('[data-nnom-discount-code]');
    if (input) input.setAttribute('aria-invalid',tone === 'error' ? 'true' : 'false');
  }
  function renderCartManualDiscounts(scope,cart) {
    var list = scope.querySelector('[data-nnom-discount-applied]');
    if (!list) return;
    if (cart) scope._nnomManualCart = cart;
    cart = cart || scope._nnomManualCart;
    if (!cart) return;
    var fragment = document.createDocumentFragment();
    manualCartPromoEntries(scope,cart).forEach(function (entry) {
      var chip = document.createElement('li'),name = document.createElement('span'),remove = document.createElement('button');
      chip.className = 'nnom-cart-discount__chip';
      chip.dataset.state = entry.applicable === false ? 'pending' : 'active';
      name.textContent = entry.code;
      remove.type = 'button'; remove.dataset.nnomDiscountRemove = entry.code;
      remove.textContent = cartDiscountMessage(scope,'remove');
      remove.setAttribute('aria-label',cartDiscountMessage(scope,'remove') + ' ' + entry.code);
      remove.disabled = manualDiscountBusy;
      chip.append(name,remove); fragment.appendChild(chip);
    });
    list.replaceChildren(fragment); list.hidden = !list.childElementCount;
    if (manualDiscountNotice && (!manualDiscountNotice.token || manualDiscountNotice.token === cart.token)) {
      setCartDiscountStatus(scope,manualDiscountNotice.key,manualDiscountNotice.tone);
    }
  }
  function applyManualCartDiscount(scope,removeCode) {
    if (!scope || manualDiscountBusy || scope.getAttribute('aria-busy') === 'true') return;
    var input = scope.querySelector('[data-nnom-discount-code]');
    var raw = input && input.value.trim(),code = removeCode ? cleanCartDiscountCode(removeCode) : cleanCartDiscountCode(raw);
    if (!code) { setCartDiscountStatus(scope,raw ? 'invalid' : 'empty','error'); if (input) input.focus(); return; }
    if (isCartRewardsSelected(scope) || scope.dataset.reservationId) {
      setCartDiscountStatus(scope,'xuConflict','warning'); return;
    }
    manualDiscountBusy = true;
    setCartRewardsBusy(scope,true); setCartDiscountStatus(scope,'loading');
    var controller = new AbortController(),timeout = window.setTimeout(function () { controller.abort(); },12000);
    var keepOpen = Boolean(scope.querySelector('[data-nnom-rewards-modal][open]')),changedCart = null;
    return fetch(cartStateUrl(),{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal}).then(parseJson).then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
      var codes = cartPromoEntries(cart).map(function (entry) { return entry.code; });
      if (removeCode) codes = codes.filter(function (item) { return item.toUpperCase() !== code.toUpperCase(); });
      else codes.push(code);
      return updateCartDiscountCodes(uniqueCartDiscountCodes(codes),controller.signal);
    }).then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
      changedCart = cart;
      var entry = cartPromoEntries(cart).find(function (item) { return item.code.toUpperCase() === code.toUpperCase(); });
      var key = removeCode ? 'removed' : entry && entry.applicable === true ? 'applied' : entry && entry.applicable === false ? 'ineligible' : 'pending';
      manualDiscountNotice = {token:cart.token,key:key,tone:key === 'ineligible' ? 'warning' : key === 'pending' ? null : 'success'};
      if (input && key !== 'ineligible') input.value = '';
      document.querySelectorAll('[data-nnom-cart-rewards]').forEach(function (other) { renderSelectedBenefitVoucher(other,cart); });
      return refreshCartDrawer(cart).then(function () {
        if (keepOpen) { rewardsDialogShouldStayOpen = true; restoreRewardsDialog(8); }
        var current = document.querySelector('cart-drawer [data-nnom-cart-rewards]');
        if (current) { renderCartManualDiscounts(current,cart); if (key === 'ineligible') current.querySelector('[data-nnom-discount-code]').value = code; }
      });
    }).catch(function () {
      if (!changedCart) { manualDiscountNotice = null; setCartDiscountStatus(scope,'failed','error'); }
      else setCartDiscountStatus(scope,manualDiscountNotice.key,manualDiscountNotice.tone);
    }).finally(function () {
      window.clearTimeout(timeout); manualDiscountBusy = false;
      if (scope.isConnected) setCartRewardsBusy(scope,false);
      var current = document.querySelector('cart-drawer [data-nnom-cart-rewards]');
      if (current && current !== scope) current.querySelectorAll('[data-nnom-discount-remove]').forEach(function (button) { button.disabled = false; });
    });
  }

  function readSelectedVoucherCodes(value) {
    if (!value) return [];
    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.map(safeCode).filter(Boolean);
    } catch (error) { /* Older carts store a single code. */ }
    var legacy = safeCode(value);
    return legacy ? [legacy] : [];
  }

  function refreshCartDrawer(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && cart && typeof drawer.renderRewardsSections === 'function' && drawer.renderRewardsSections(cart)) return Promise.resolve();
    return drawer && typeof drawer.reload === 'function' ? drawer.reload() : Promise.resolve();
  }

  var rewardsDialogShouldStayOpen = false;
  function restoreRewardsDialog(attempts) {
    if (!rewardsDialogShouldStayOpen) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
    var dialog = drawer && drawer.querySelector('[data-nnom-rewards-modal]');
    var scope = dialog && dialog.closest('[data-nnom-cart-rewards]');
    if (dialog && scope && document.body.contains(dialog)) {
      if (!dialog.open) {
        try { dialog.showModal(); } catch (error) { /* Drawer can still be rendering. */ }
      }
      if (dialog.open) {
        hydrateCartRewards(scope);
        return;
      }
    }
    if (attempts > 0) window.setTimeout(function () { restoreRewardsDialog(attempts - 1); }, 100);
  }

  function restoreRewardsAfterSignIn() {
    var url = new URL(window.location.href);
    if (url.searchParams.get('prima_rewards') !== '1') return;
    url.searchParams.delete('prima_rewards');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    rewardsDialogShouldStayOpen = true;
    restoreRewardsDialog(8);
  }

  function loadStoredReferral() {
    try {
      var value = JSON.parse(window.localStorage.getItem(referralStorageKey) || 'null');
      if (!value || !value.code || !value.capturedAt || !value.expiresAt) return null;
      if (Date.now() > Number(value.expiresAt)) {
        window.localStorage.removeItem(referralStorageKey);
        return null;
      }
      return value;
    } catch (error) {
      return null;
    }
  }

  function captureReferral() {
    var params = new URLSearchParams(window.location.search);
    var code = safeCode(params.get('ref'));
    var depot = safeCode(params.get('depot'));
    var stored = loadStoredReferral();

    if (code) {
      var capturedAt = new Date();
      var expiresAt = new Date(capturedAt.getTime());
      expiresAt.setMonth(expiresAt.getMonth() + 24);
      stored = { code: code, depot: depot, capturedAt: capturedAt.getTime(), expiresAt: expiresAt.getTime() };
      try { window.localStorage.setItem(referralStorageKey, JSON.stringify(stored)); } catch (error) { /* Storage can be blocked. */ }
    }

    if (!stored) return;
    var syncFingerprint = stored.code + '|' + (stored.depot || '') + '|' + stored.capturedAt;
    try {
      if (window.sessionStorage.getItem(referralSyncKey) === syncFingerprint) return;
    } catch (error) { /* Session storage can be blocked. */ }
    var attributes = {
      'NNOM Referral Code': stored.code,
      'NNOM Referral Captured At': new Date(Number(stored.capturedAt)).toISOString()
    };
    if (stored.depot) attributes['NNOM Referral Depot'] = stored.depot;
    updateCartAttributes(attributes)
      .then(function () {
        try { window.sessionStorage.setItem(referralSyncKey, syncFingerprint); } catch (error) { /* Session storage can be blocked. */ }
      })
      .catch(function () { /* Retry on the next page view. */ });
  }

  function handleDepotChange(select) {
    var value = safeCode(select.value);
    var scopes = document.querySelectorAll('[data-nnom-rewards-cart]');
    scopes.forEach(function (scope) { setStatus(scope, tr('dang_luu_kho_dai_ly_9f0c213a',"Đang lưu kho/đại lý…")); });
    document.querySelectorAll('[data-nnom-rewards-depot]').forEach(function (other) {
      if (other !== select) other.value = value;
    });

    updateCartAttributes({ 'NNOM Depot ID': value })
      .then(function () {
        scopes.forEach(function (scope) { setStatus(scope, value ? tr('da_luu_kho_dai_ly_cho_don_hang_dcf0ff73',"Đã lưu kho/đại lý cho đơn hàng.") : tr('vui_long_chon_kho_dai_ly_57ca49a3',"Vui lòng chọn kho/đại lý."), value ? 'success' : 'warning'); });
      })
      .catch(function () {
        scopes.forEach(function (scope) { setStatus(scope, tr('khong_the_luu_kho_dai_ly_vui_long_thu_lai_7aa5b6a5',"Không thể lưu kho/đại lý. Vui lòng thử lại."), 'error'); });
      });
  }

  function applyRewards(button) {
    var scope = button.closest('[data-nnom-rewards-cart]');
    var depot = selectedDepot();
    if (!depot) {
      setStatus(scope, tr('vui_long_chon_kho_dai_ly_truoc_khi_ap_dung_die_f2c70cc7',"Vui lòng chọn kho/đại lý trước khi áp dụng điểm."), 'error');
      var select = scope.querySelector('[data-nnom-rewards-depot]');
      if (select) select.focus();
      return;
    }

    setButtonBusy(button, true);
    setStatus(scope, tr('dang_kiem_tra_va_khoa_so_diem_co_the_su_dung_b44aefde',"Đang kiểm tra và khóa số điểm có thể sử dụng…"));

    fetch(cartStateUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parseJson)
      .then(function (cart) {
        return request('/api/redemptions', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            mode: 'auto',
            priority: ['LP'],
            depot_id: depot,
            cart_token: cart.token,
            cart_total: cart.total_price,
            currency: cart.currency
          })
        });
      })
      .then(function (result) {
        if (!result.redirect_url && !result.discount_code) {
          throw new Error(tr('dich_vu_diem_chua_tra_ve_checkout_hop_le_2d40d7b1',"Dịch vụ điểm chưa trả về checkout hợp lệ."));
        }
        var attributes = {
          'NNOM Rewards Reservation': result.reservation_id || '',
          'NNOM LP Redeemed': String(result.lp_points || 0),
          'NNOM Depot ID': depot
        };
        return updateCartAttributes(attributes).then(function () { return result; });
      })
      .then(function (result) {
        setStatus(scope, tr('da_khoa_diem_dang_chuyen_toi_thanh_toan_78f02ec8',"Đã khóa điểm. Đang chuyển tới thanh toán…"), 'success');
        if (result.redirect_url) {
          window.location.assign(result.redirect_url);
          return;
        }
        var redirect = '/discount/' + encodeURIComponent(result.discount_code) + '?redirect=' + encodeURIComponent('/checkout');
        window.location.assign(redirect);
      })
      .catch(function (error) {
        var message = error.name === 'AbortError'
          ? tr('dich_vu_diem_phan_hoi_qua_lau_vui_long_thu_lai_08d229ed',"Dịch vụ điểm phản hồi quá lâu. Vui lòng thử lại.")
          : error.message;
        setStatus(scope, message || tr('khong_the_ap_dung_diem_vui_long_thu_lai_894f68ad',"Không thể áp dụng điểm. Vui lòng thử lại."), 'error');
        setButtonBusy(button, false);
      });
  }

  function copyInvite(button) {
    var scope = button.closest('[data-nnom-rewards-portal]');
    var input = scope && scope.querySelector('[data-nnom-rewards-invite]');
    if (!input || !input.value) {
      setStatus(scope, tr('ma_gioi_thieu_chua_duoc_cap_cf09fd84',"Mã giới thiệu chưa được cấp."), 'error');
      return;
    }

    var copyPromise = navigator.clipboard && window.isSecureContext
      ? navigator.clipboard.writeText(input.value)
      : Promise.reject(new Error('clipboard-unavailable'));

    copyPromise
      .then(function () { setStatus(scope, tr('da_sao_chep_duong_dan_gioi_thieu_6f3e6c7f',"Đã sao chép đường dẫn giới thiệu."), 'success'); })
      .catch(function () {
        input.focus();
        input.select();
        setStatus(scope, tr('duong_dan_da_duoc_chon_nhan_ctrl_c_de_sao_chep_b2e629bb',"Đường dẫn đã được chọn. Nhấn Ctrl+C để sao chép."), 'warning');
      });
  }

  function pollVoucher(reservationId, attempts) {
    if (attempts <= 0) {
      return Promise.reject(new Error(tr('voucher_dang_duoc_tao_vui_long_thu_lai_sau_it__2ad07310',"Voucher đang được tạo. Vui lòng thử lại sau ít phút.")));
    }
    return new Promise(function (resolve) { window.setTimeout(resolve, 800); })
      .then(function () { return request('/redeem?reservationId=' + encodeURIComponent(reservationId)); })
      .then(function (result) {
        if (result.ready && result.reservation && result.reservation.checkoutPath) return result;
        return pollVoucher(reservationId, attempts - 1);
      });
  }

  function setCartRewardsStatus(scope, message, tone) {
    var status = scope && scope.querySelector('[data-nnom-cart-rewards-status]');
    if (!status) return;
    status.textContent = message || '';
    if (tone) status.dataset.tone = tone;
    else status.removeAttribute('data-tone');
  }

  function setCartRewardsBusy(scope, busy) {
    if (scope) scope.querySelectorAll('[data-nnom-discount-code],[data-nnom-discount-apply],[data-nnom-discount-remove]').forEach(function (control) { control.disabled = Boolean(busy); });
    var toggles = scope && scope.querySelectorAll('[data-nnom-cart-rewards-toggle]');
    var voucherButtons = scope && scope.querySelectorAll('[data-nnom-cart-voucher-code]');
    var voucherSelect = scope && scope.querySelector('[data-nnom-benefit-select]');
    var checkout = scope && scope.dataset.nnomCartView === 'full'
      ? document.getElementById('checkout')
      : document.getElementById('CartDrawer-Checkout');
    if (toggles) {
      toggles.forEach(function (toggle) {
        toggle.disabled = Boolean(busy);
        toggle.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
    }
    var xuSwitch = scope && scope.querySelector('[data-nnom-cart-rewards-switch]');
    if (xuSwitch) { xuSwitch.disabled = Boolean(busy); xuSwitch.setAttribute('aria-busy', busy ? 'true' : 'false'); }
    if (checkout) checkout.disabled = Boolean(busy);
    if (voucherButtons) voucherButtons.forEach(function (button) { button.disabled = Boolean(busy); });
    if (voucherSelect) voucherSelect.disabled = Boolean(busy) || scope.dataset.benefitVoucherAvailable === 'false';
    if (scope) scope.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function cartTotalVnd(cart) {
    if (String(cart && cart.currency || '').toUpperCase() !== 'VND') return 0;
    return Math.max(0, Math.floor(Number(cart && cart.total_price || 0) / 100));
  }

  function cartSubtotalVnd(cart) {
    if (String(cart && cart.currency || '').toUpperCase() !== 'VND') return 0;
    var cents = Number(cart && cart.original_total_price || 0);
    if (!cents) cents = Number(cart && cart.total_price || 0) + Number(cart && cart.total_discount || 0);
    return Math.max(0, Math.floor(cents / 100));
  }

  function cartRewardControls(scope) {
    var container = scope.closest('cart-drawer') || scope.closest('#main-cart-footer');
    var totalValue = container && container.querySelector('[data-nnom-cart-total-value]');
    return {
      toggles: scope.querySelectorAll('[data-nnom-cart-rewards-toggle]'),
      details: scope.querySelector('[data-nnom-cart-rewards-details]'),
      amount: scope.querySelector('[name="nnom-cart-rewards-points"]'),
       help: scope.querySelector('[data-nnom-cart-rewards-help]'),
       balance: scope.querySelector('[data-nnom-cart-rewards-balance]'),
      discount: scope.querySelector('[data-nnom-cart-rewards-discount]'),
       discountValue: scope.querySelector('[data-nnom-cart-rewards-discount-value]'),
       total: totalValue && (totalValue.querySelector('[data-nnom-cart-total-current]') || totalValue),
       totalLabel: container && container.querySelector('[data-nnom-cart-total-label]')
    };
  }

  function formatMoney(value) {
    return new Intl.NumberFormat(displayLocale).format(Math.max(0, Math.floor(Number(value) || 0))) + '₫';
  }

  function renderCartRewardTotal(scope, rewardDiscount) {
    var controls = cartRewardControls(scope);
    var baseTotal = Math.max(0, Number(scope.dataset.cartTotalVnd || 0));
    if (!controls.total || !Number.isFinite(baseTotal)) return;
    var discount = Math.min(baseTotal, Math.max(0, Math.floor(Number(rewardDiscount) || 0)));
    controls.total.textContent = formatMoney(baseTotal - discount);
    if (controls.totalLabel) {
      controls.totalLabel.textContent = discount > 0 ? tr('tam_tinh_sau_uu_dai_uoc_tinh_5ffc7f1f',"Tạm tính sau ưu đãi (ước tính)") : tr('tong_tam_tinh_bfedd05f',"Tổng tạm tính");
    }
  }

  function renderCartRewardDiscount(scope, amount, label) {
    var controls = cartRewardControls(scope);
    var value = Math.max(0, Math.floor(Number(amount) || 0));
    if (controls.discount && controls.discountValue) {
      controls.discount.hidden = value <= 0;
      controls.discountValue.textContent = formatMoney(value);
      controls.discount.dataset.state = label || '';
    }
    renderCartRewardTotal(scope, value);
  }

  function setCartRewardContext(scope, wallet, cart) {
    var controls = cartRewardControls(scope);
    var unit = Number(wallet && wallet.conversion && wallet.conversion.lpValueVnd || 0);
    var available = Number(wallet && wallet.balances && wallet.balances.lp && wallet.balances.lp.available || 0);
    var total = cartTotalVnd(cart);
    var maximum = unit > 0 ? Math.min(available, Math.floor(total / unit)) : 0;
    scope.dataset.cartTotalVnd = String(total);
    scope.dataset.rewardsUnitVnd = String(unit);
    scope.dataset.rewardsMaxLp = String(maximum);
    if (controls.balance) controls.balance.textContent = formatPoints(available) + tr('xu_kha_dung_55bb8e58'," Xu khả dụng");
    return { unit: unit, available: available, maximum: maximum };
  }

  function cartVoucherEligibility(cart) {
    var productIds = (cart && cart.items || []).map(function (item) {
      var value = String(item && (item.product_id || item.productId) || '').trim();
      var match = value.match(/(?:^|\/)(\d+)$/);
      return match ? match[1] : '';
    }).filter(Boolean);
    productIds = productIds.filter(function (id, index) { return productIds.indexOf(id) === index; });
    if (!productIds.length) return Promise.resolve({ eligibleVoucherIds: [] });
    return request('/voucher-eligibility', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ productIds: productIds })
    });
  }

  function voucherCombinesWith(left, right) {
    if (right.discountType === 'FREE_SHIPPING') return left.discountType !== 'FREE_SHIPPING';
    var rightIsOrderDiscount = right.appliesToType === 'ALL';
    return rightIsOrderDiscount ? left.combineOrderDiscounts === true : left.combineProductDiscounts === true;
  }

  function vouchersCanCombine(left, right) {
    return Boolean(left && right && voucherCombinesWith(left, right) && voucherCombinesWith(right, left));
  }

  function compatibleVoucherCodes(codes, vouchers, allowMultiple) {
    var selected = [];
    (codes || []).forEach(function (code) {
      var voucher = vouchers.find(function (item) { return item.code === code; });
      if (!voucher || selected.includes(code) || selected.length >= (allowMultiple ? 5 : 1)) return;
      if (selected.every(function (current) { return vouchersCanCombine(voucher, vouchers.find(function (item) { return item.code === current; })); })) selected.push(code);
    });
    return selected;
  }

  function populateBenefitSelect(scope, wallet, cart, eligibility) {
    var select = scope.querySelector('[data-nnom-benefit-select]');
    if (!select) return;
    var eligibleIds = new Set(eligibility && eligibility.eligibleVoucherIds || []);
    var vouchers = (wallet.vouchers || []).filter(function (voucher) {
      return voucher && voucher.code && (Number(voucher.amountVnd) > 0 || voucher.discountType === 'PERCENTAGE' || voucher.discountType === 'FREE_SHIPPING') && eligibleIds.has(voucher.id);
    });
    scope._nnomBenefitVouchers = vouchers;
    scope.dataset.benefitVoucherAvailable = vouchers.length ? 'true' : 'false';
    var selectedCodes = readSelectedVoucherCodes(cart && cart.attributes && (cart.attributes['NNOM Selected Vouchers'] || cart.attributes['NNOM Selected Voucher']) || scope.dataset.selectedVouchers || scope.dataset.selectedVoucher || '');
    var allowMultiple = Boolean(wallet.voucherPolicy && wallet.voucherPolicy.allowMultiple);
    scope.dataset.allowMultipleVouchers = allowMultiple ? 'true' : 'false';
    var policyNote = scope.querySelector('[data-nnom-voucher-policy-note]');
    if (policyNote) policyNote.textContent = allowMultiple ? tr('toi_da_5_ma_phu_hop_shopify_xac_nhan_so_giam_t_a289f2ea',"Tối đa 5 mã phù hợp; Shopify xác nhận số giảm thực tế.") : tr('chon_mot_ma_phu_hop_nhat_4783749b',"Chọn một mã phù hợp nhất.");
    selectedCodes = compatibleVoucherCodes(selectedCodes, vouchers, allowMultiple);
    scope.dataset.selectedVouchers = JSON.stringify(selectedCodes);
    scope.dataset.selectedVoucher = selectedCodes[0] || '';
    select.textContent = '';
    var cardList = scope.querySelector('[data-nnom-voucher-cards]');
    if (cardList) cardList.textContent = '';
    var empty = document.createElement('option');
    empty.value = '';
    empty.textContent = vouchers.length
      ? tr('khong_dung_voucher_00ed0522',"Không dùng voucher")
      : tr('chua_co_voucher_1cdec6f5',"Chưa có voucher");
    select.appendChild(empty);
    if (cardList) {
      var none = document.createElement('button');
      none.type = 'button';
      none.className = 'nnom-cart-rewards__voucher-none';
      none.dataset.nnomCartVoucherCode = '';
      none.textContent = tr('khong_dung_voucher_00ed0522',"Không dùng voucher");
      none.setAttribute('aria-pressed', selectedCodes.length ? 'false' : 'true');
      cardList.appendChild(none);
    }
    vouchers.forEach(function (voucher) {
      var option = document.createElement('option');
      option.value = voucher.code;
      var minimum = Math.max(0, Number(voucher.minimumSubtotalVnd || 0));
      option.disabled = minimum > cartSubtotalVnd(cart);
      option.textContent = (voucher.kind === 'BIRTHDAY' ? tr('sinh_nhat_faaf8cf2',"Sinh nhật") : voucher.kind === 'MANUAL' ? tr('uu_dai_rieng_5fcc4810',"Ưu đãi riêng") : voucher.kind === 'POINT_REDEMPTION' ? tr('doi_prima_xu_711045ca',"Đổi Prima Xu") : tr('thanh_vien_2dfff33e',"Thành viên")) + ' · ' + voucherValue(voucher) + (minimum ? tr('don_tu_3053e076'," · Đơn từ ") + formatMoney(minimum) : '') + (option.disabled ? tr('chua_du_7a88f696'," (chưa đủ)") : '');
      select.appendChild(option);
      if (cardList) {
        var ticket = document.createElement('article');
        ticket.className = 'nnom-cart-rewards__voucher-ticket';
        var value = document.createElement('strong');
        value.className = 'nnom-cart-rewards__voucher-value';
        value.textContent = (voucher.discountType === 'FREE_SHIPPING' ? '' : tr('giam_a6c2901a',"Giảm ")) + voucherValue(voucher);
        var meta = document.createElement('div');
        meta.className = 'nnom-cart-rewards__voucher-meta';
        var label = document.createElement('strong');
        label.textContent = voucher.displayTitle || (voucher.kind === 'BIRTHDAY' ? tr('qua_sinh_nhat_01f4dd9e',"Quà sinh nhật") : voucher.kind === 'POINT_REDEMPTION' ? tr('doi_prima_xu_711045ca',"Đổi Prima Xu") : voucher.kind === 'MANUAL' ? tr('uu_dai_rieng_5fcc4810',"Ưu đãi riêng") : tr('voucher_thanh_vien_e6f0e756',"Voucher thành viên"));
        var description = document.createElement('span');
        description.className = 'nnom-cart-rewards__voucher-description';
        description.textContent = voucher.displayDescription || '';
        var condition = document.createElement('span');
        condition.className = 'nnom-cart-rewards__voucher-conditions';
        var conditions = [];
        if (minimum) conditions.push(tr('don_tu_db5eb99e',"Đơn từ ") + formatMoney(minimum));
        if (voucher.appliesToType === 'PRODUCT') conditions.push(tr('san_pham_c39f2b68',"Sản phẩm: ") + (voucher.appliesToLabel || tr('cu_the_202a3aa5',"cụ thể")));
        else if (voucher.appliesToType === 'COLLECTION') conditions.push('Collection: ' + (voucher.appliesToLabel || tr('cu_the_202a3aa5',"cụ thể")));
        else if (voucher.appliesToType === 'TAG') conditions.push('Tag: ' + (voucher.appliesToLabel || voucher.appliesToValue));
        else conditions.push(tr('toan_bo_don_hang_929555e2',"Toàn bộ đơn hàng"));
        if (Number(voucher.pointsCostXu) > 0) conditions.push(tr('da_doi_6b36cd10',"Đã đổi ") + formatPoints(voucher.pointsCostXu) + ' Xu');
        if (voucher.expiresAt) conditions.push(tr('het_han_a45e2ce1',"Hết hạn ") + new Date(voucher.expiresAt).toLocaleDateString(displayLocale));
        if (voucher.combineOrderDiscounts !== true) conditions.push(tr('khong_ket_hop_ma_giam_don_khac_b5d92351',"Không kết hợp mã giảm đơn khác"));
        condition.textContent = conditions.join(' · ') + (option.disabled ? tr('chua_dat_dieu_kien_1e75eb62'," · Chưa đạt điều kiện") : '');
        meta.appendChild(label);
        if (description.textContent) meta.appendChild(description);
        meta.appendChild(condition);
        var pick = document.createElement('button');
        pick.type = 'button';
        pick.className = 'nnom-cart-rewards__voucher-pick';
        pick.dataset.nnomCartVoucherCode = voucher.code;
        var isSelected = selectedCodes.includes(voucher.code);
        pick.disabled = option.disabled || (allowMultiple && selectedCodes.length >= 5 && !isSelected);
        pick.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        pick.textContent = isSelected ? tr('da_chon_7f7e38b3',"Đã chọn") : option.disabled ? tr('chua_du_db3a1072',"Chưa đủ") : tr('chon_ma_9e7c9e93',"Chọn mã");
        ticket.appendChild(value);
        ticket.appendChild(meta);
        ticket.appendChild(pick);
        cardList.appendChild(ticket);
      }
    });
    select.value = selectedCodes[0] || '';
    select.disabled = !vouchers.length;
    if (selectedCodes.length && selectedCodes.length !== readSelectedVoucherCodes(cart && cart.attributes && (cart.attributes['NNOM Selected Vouchers'] || cart.attributes['NNOM Selected Voucher']) || '').length) {
      setCartRewardsStatus(scope, tr('mot_so_voucher_khong_ap_dung_cho_san_pham_hien_765584a6',"Một số voucher không áp dụng cho sản phẩm hiện có trong giỏ và đã được bỏ chọn."), 'warning');
    }
    var tierName = scope.querySelector('[data-nnom-cart-tier-name]');
    if (tierName) tierName.textContent = wallet.tier && wallet.tier.name || 'Member';
    var nextExpiring = scope.querySelector('[data-nnom-cart-next-expiring]');
    if (nextExpiring) nextExpiring.textContent = wallet.nextExpiring && wallet.nextExpiring.expiresAt
      ? formatPoints(wallet.nextExpiring.remainingAmount) + ' Xu · ' + new Date(wallet.nextExpiring.expiresAt).toLocaleDateString(displayLocale)
      : tr('chua_co_bc2b97d6',"Chưa có");
    renderSelectedBenefitVoucher(scope);
  }

  function renderSelectedBenefitVoucher(scope, cart) {
    renderCartManualDiscounts(scope,cart);
    if (scope.dataset.reservationId || isCartRewardsSelected(scope)) return;
    var controls = cartRewardControls(scope);
    var select = scope.querySelector('[data-nnom-benefit-select]');
    var selectedCodes = readSelectedVoucherCodes(scope.dataset.selectedVouchers || (select && select.value) || '');
    var selected = (scope._nnomBenefitVouchers || []).filter(function (item) { return selectedCodes.includes(item.code); });
    var summary = scope.querySelector('[data-nnom-cart-selected-summary]');
    var manualCount = manualCartPromoEntries(scope,cart || scope._nnomManualCart).length;
    if (summary) summary.textContent = selected.length ? selected.length + tr('voucher_da_chon_e2077aaa'," voucher đã chọn") : manualCount ? cartDiscountMessage(scope,'selected') : tr('chua_chon_e5f50074',"Chưa chọn");
    if (cart) {
      var appliedDiscount = Math.floor(Number(cart.total_discount || 0) / 100);
      if (controls.discount && controls.discountValue) {
        controls.discount.hidden = appliedDiscount <= 0;
        controls.discountValue.textContent = formatMoney(appliedDiscount);
      }
      if (controls.total) controls.total.textContent = formatMoney(cartTotalVnd(cart));
      if (controls.totalLabel) controls.totalLabel.textContent = tr('tam_tinh_d115fee4',"Tạm tính");
    }
  }

  function previewCartRewardDiscount(scope) {
    if (!scope || scope.dataset.reservationId) return;
    var controls = cartRewardControls(scope);
    if (!controls.amount || controls.amount.disabled) return;
    var points = Math.max(0, Math.floor(Number(controls.amount.value) || 0));
    var maximum = Math.max(0, Number(scope.dataset.rewardsMaxLp || 0));
    var valuePerPoint = Math.max(0, Number(scope.dataset.rewardsUnitVnd || 0));
    renderCartRewardDiscount(scope, Math.min(points, maximum) * valuePerPoint, 'preview');
  }

  function setCartRewardsSelected(scope, selected) {
    var controls = cartRewardControls(scope);
    var xuSwitch = scope.querySelector('[data-nnom-cart-rewards-switch]');
    if (xuSwitch) xuSwitch.setAttribute('aria-checked', selected ? 'true' : 'false');
    if (!controls.toggles.length && !xuSwitch) return;
    controls.toggles.forEach(function (toggle) {
      var mode = toggle.dataset.nnomCartRewardsMode;
      toggle.setAttribute('aria-pressed', selected ? (mode === 'on' ? 'true' : 'false') : (mode === 'off' ? 'true' : 'false'));
    });
    if (controls.details) controls.details.hidden = !selected;
    if (controls.amount) controls.amount.disabled = !selected || scope.dataset.rewardsReady !== 'true';
    if (scope.dataset.nnomCartView !== 'full') {
      var summary = scope.querySelector('[data-nnom-cart-selected-summary]');
      if (summary && selected) summary.textContent = tr('dung_prima_xu_ac0c25e2',"Dùng Prima Xu");
      if (summary && !selected && !scope.dataset.selectedVoucher) summary.textContent = tr('chua_chon_e5f50074',"Chưa chọn");
    }
  }

  function isCartRewardsSelected(scope) {
    var xuSwitch = scope && scope.querySelector('[data-nnom-cart-rewards-switch]');
    if (xuSwitch) return xuSwitch.getAttribute('aria-checked') === 'true';
    var selected = scope && scope.querySelector('[data-nnom-cart-rewards-toggle][data-nnom-cart-rewards-mode="on"]');
    return Boolean(selected && selected.getAttribute('aria-pressed') === 'true');
  }

  function clearCartRewardReservation(scope) {
    delete scope.dataset.reservationId;
    delete scope.dataset.reservationStatus;
    delete scope.dataset.checkoutPath;
  }

  function resetCartRewardScope(scope) {
    if (!scope) return;
    clearCartRewardReservation(scope);
    delete scope.dataset.cartRewardsHydrated;
    delete scope.dataset.rewardsReady;
    delete scope.dataset.rewardsMaxLp;
    delete scope.dataset.rewardsUnitVnd;
    var controls = cartRewardControls(scope);
    if (controls.amount) {
      controls.amount.value = '';
      controls.amount.disabled = true;
    }
    setCartRewardsBusy(scope, false);
    renderCartRewardDiscount(scope, 0);
    setCartRewardsSelected(scope, false);
    setCartRewardsStatus(scope, '');
  }

  function showCartRewardReservation(scope, result) {
    var reservation = result && result.reservation;
    if (!reservation) return false;
    var controls = cartRewardControls(scope);
    scope.dataset.reservationId = reservation.id || '';
    scope.dataset.reservationStatus = reservation.status || '';
    scope.dataset.checkoutPath = reservation.checkoutPath || '';
    scope.dataset.rewardsReady = 'false';
    if (controls.amount) {
      controls.amount.value = String(reservation.lpPoints || '');
      controls.amount.disabled = true;
    }
    if (controls.help) controls.help.textContent = formatPoints(reservation.lpPoints || 0) + tr('prima_xu_da_duoc_giu_cho_gio_hang_nay_ad1a71df'," Prima Xu đã được giữ cho giỏ hàng này.");
    var summary = scope.querySelector('[data-nnom-cart-selected-summary]');
    if (summary) summary.textContent = formatPoints(reservation.lpPoints || 0) + ' Prima Xu';
    renderCartRewardDiscount(scope, reservation.discountAmount, result.ready ? 'ready' : 'pending');
    setCartRewardsSelected(scope, true);
    setCartRewardsStatus(
      scope,
      result.ready
        ? tr('voucher_da_san_sang_bam_thanh_toan_ngay_de_ap__0c01739b',"Voucher đã sẵn sàng. Bấm Thanh toán ngay để áp dụng điểm.")
        : tr('voucher_dang_duoc_tao_ban_co_the_thanh_toan_sa_d2ab81f8',"Voucher đang được tạo. Bạn có thể thanh toán sau vài giây."),
      result.ready ? 'success' : 'warning'
    );
    return true;
  }

  function fetchCartRewardReservation(scope, cart) {
    if (!cart || !cart.token) return Promise.resolve(null);
    return request('/redeem?cartToken=' + encodeURIComponent(cart.token))
      .then(function (result) {
        showCartRewardReservation(scope, result);
        return result;
      })
      .catch(function (error) {
        if (error && error.status === 404) return null;
        throw error;
      });
  }

  function hydrateCartRewards(scope) {
    // Guests can use native Shopify codes, but never request a private wallet.
    if (scope && scope.dataset.customerAuthenticated !== 'true') {
      if (scope.dataset.guestDiscountHydrated === 'true') return;
      scope.dataset.guestDiscountHydrated = 'true';
      fetch(cartStateUrl(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(parseJson).then(function (cart) { renderCartManualDiscounts(scope, cart); })
        .catch(function () { delete scope.dataset.guestDiscountHydrated; });
      return;
    }
    if (!scope || scope.dataset.customerAuthenticated !== 'true' || scope.dataset.cartRewardsHydrated === 'true') return;
    scope.dataset.cartRewardsHydrated = 'true';
    if (window.PrimaSkeleton) window.PrimaSkeleton.setLoading(scope, true);
    Promise.all([
      getWallet(),
      fetch(cartStateUrl(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(parseJson)
    ])
      .then(function (values) {
        var cart = values[1];
        setCartRewardContext(scope, values[0], cart);
        return cartVoucherEligibility(cart).then(function (eligibility) {
          populateBenefitSelect(scope, values[0], cart, eligibility);
          renderSelectedBenefitVoucher(scope, cart);
          return { wallet: values[0], cart: cart };
        });
      })
      .then(function (values) {
        var cart = values.cart;
        return fetchCartRewardReservation(scope, cart);
      })
      .then(function (result) {
        if (!result) renderSelectedBenefitVoucher(scope);
      })
      .catch(function () {
        scope.dataset.cartRewardsHydrated = 'false';
        setCartRewardsStatus(scope, tr('chua_tai_duoc_vi_va_voucher_vui_long_tai_lai_t_12266d3e',"Chưa tải được ví và voucher. Vui lòng tải lại trang để thử lại."), 'warning');
      }).finally(function () {
        if (window.PrimaSkeleton) window.PrimaSkeleton.setLoading(scope, false);
      });
  }

  function prepareCartRewards(scope) {
    var controls = cartRewardControls(scope);
    if (!controls.amount && scope.dataset.nnomCartView === 'full') return Promise.resolve(false);
    setCartRewardsBusy(scope, true);
    setCartRewardsStatus(scope, tr('dang_kiem_tra_so_du_va_gia_tri_gio_hang_9386ec9c',"Đang kiểm tra số dư và giá trị giỏ hàng…"));
    return Promise.all([
      getWallet(true),
      fetch(cartStateUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(parseJson)
    ])
      .then(function (values) {
        var wallet = values[0];
        var cart = values[1];
        var selectedCodes = readSelectedVoucherCodes(cart && cart.attributes && (cart.attributes['NNOM Selected Vouchers'] || cart.attributes['NNOM Selected Voucher']) || '');
        return cartVoucherEligibility(cart).then(function (eligibility) {
          populateBenefitSelect(scope, wallet, cart, eligibility);
          renderSelectedBenefitVoucher(scope, cart);
          return { wallet: wallet, cart: cart, selectedCodes: selectedCodes };
        });
      })
      .then(function (contextResult) {
        var wallet = contextResult.wallet;
        var cart = contextResult.cart;
        var context = setCartRewardContext(scope, wallet, cart);
        var unit = context.unit;
        var available = context.available;
        var maximum = context.maximum;
         if (controls.balance) controls.balance.textContent = formatPoints(available) + tr('xu_kha_dung_55bb8e58'," Xu khả dụng");
        if (unit <= 0 || maximum <= 0) {
          scope.dataset.rewardsReady = 'false';
          if (controls.amount) controls.amount.disabled = true;
          setCartRewardsSelected(scope, false);
          setCartRewardsStatus(scope, available <= 0
            ? tr('ban_chua_co_prima_xu_kha_dung_cho_don_hang_nay_a830aec1',"Bạn chưa có Prima Xu khả dụng cho đơn hàng này.")
            : tr('gio_hang_chua_du_gia_tri_toi_thieu_de_dung_die_5875b8f4',"Giỏ hàng chưa đủ giá trị tối thiểu để dùng điểm."), 'warning');
          return false;
        }
        scope.dataset.rewardsReady = 'true';
        if (controls.amount) {
          controls.amount.min = '1';
          controls.amount.max = String(maximum);
          controls.amount.step = '1';
          var currentValue = Math.floor(Number(controls.amount.value));
          controls.amount.value = currentValue >= 1 && currentValue <= maximum ? String(currentValue) : '';
          controls.amount.disabled = false;
          previewCartRewardDiscount(scope);
        } else {
          renderCartRewardDiscount(scope, maximum * unit, 'preview');
        }
        if (controls.help) controls.help.textContent = tr('co_the_dung_toi_da_7afe8664',"Có thể dùng tối đa ") + formatPoints(maximum) + tr('xu_moi_xu_doi_duoc_bbf9713d'," Xu. Mỗi Xu đổi được ") + formatMoney(unit) + '.';
        setCartRewardsSelected(scope, true);
        setCartRewardsStatus(scope, controls.amount ? tr('nhap_so_prima_xu_muon_dung_voucher_chi_duoc_ta_734e5c20',"Nhập số Prima Xu muốn dùng. Voucher chỉ được tạo khi bạn bấm Thanh toán.") : tr('se_dung_toi_da_1d01f7be',"Sẽ dùng tối đa ") + formatPoints(maximum) + tr('xu_khi_thanh_toan_2c490bb5'," Xu khi thanh toán."), 'success');
        return true;
      })
      .catch(function (error) {
        setCartRewardsStatus(scope, error && error.message ? error.message : tr('chua_the_kiem_tra_vi_diem_ef27e724',"Chưa thể kiểm tra ví điểm."), 'error');
        return false;
      })
      .finally(function () { setCartRewardsBusy(scope, false); });
  }

  function disableCartRewards(scope) {
    var finish = function () {
      clearCartRewardReservation(scope);
      scope.dataset.rewardsReady = 'false';
      renderCartRewardDiscount(scope, 0);
      setCartRewardsSelected(scope, false);
      setCartRewardsStatus(scope, tr('ban_se_thanh_toan_binh_thuong_khong_dung_diem_3605e7a5',"Bạn sẽ thanh toán bình thường, không dùng điểm."), 'success');
    };
    if (!scope.dataset.reservationId) {
      finish();
      renderSelectedBenefitVoucher(scope);
      return Promise.resolve(true);
    }
    setCartRewardsBusy(scope, true);
    return fetch(cartStateUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parseJson)
      .then(function (cart) {
        return request('/redeem/cancel', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ cartToken: cart.token })
        });
      })
      .then(function () { finish(); renderSelectedBenefitVoucher(scope); return true; })
      .catch(function (error) {
        setCartRewardsStatus(scope, error && error.message ? error.message : tr('chua_the_tat_voucher_vui_long_thu_lai_08deb660',"Chưa thể tắt voucher. Vui lòng thử lại."), 'error');
        return false;
      })
      .finally(function () { setCartRewardsBusy(scope, false); });
  }

  function redeemCartRewards(scope) {
    var controls = cartRewardControls(scope);
    var amount = controls.amount ? Math.floor(Number(controls.amount.value)) : Math.floor(Number(scope.dataset.rewardsMaxLp || 0));
    var maximum = Number(scope.dataset.rewardsMaxLp || 0);
    if (!Number.isInteger(amount) || amount < 1 || amount > maximum) {
      if (controls.amount) controls.amount.focus();
      setCartRewardsStatus(scope, tr('chua_co_prima_xu_kha_dung_cho_gio_hang_nay_5e6321c4',"Chưa có Prima Xu khả dụng cho giỏ hàng này."), 'error');
      return Promise.resolve(false);
    }
    setCartRewardsBusy(scope, true);
    setCartRewardsStatus(scope, tr('dang_giu_diem_va_tao_voucher_8acd7c44',"Đang giữ điểm và tạo voucher…"));
    return fetch(cartStateUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parseJson)
      .then(function (cart) {
        return request('/redeem', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ requestedLp: amount, cartToken: cart.token })
        });
      })
      .then(function (result) {
        if (result.ready && result.reservation && result.reservation.checkoutPath) return result;
        if (!result.reservation || !result.reservation.id) throw new Error(tr('khong_the_tao_voucher_556cbeec',"Không thể tạo voucher."));
        return pollVoucher(result.reservation.id, 25);
      })
      .then(function (result) {
        setCartRewardsStatus(scope, tr('voucher_da_san_sang_dang_chuyen_toi_thanh_toan_853f9dde',"Voucher đã sẵn sàng. Đang chuyển tới thanh toán…"), 'success');
        window.location.assign(result.reservation.checkoutPath);
        return true;
      })
      .catch(function (error) {
        setCartRewardsStatus(scope, error && error.message ? error.message : tr('khong_the_tao_voucher_556cbeec',"Không thể tạo voucher."), 'error');
        return false;
      })
      .finally(function () { setCartRewardsBusy(scope, false); });
  }

  function handleCartRewardToggle(button) {
    if (manualDiscountBusy) return;
    var scope = button.closest('[data-nnom-cart-rewards]');
    if (!scope) return;
    var activating = button.matches('[data-nnom-cart-rewards-switch]') ? !isCartRewardsSelected(scope) : button.dataset.nnomCartRewardsMode === 'on';
    if (activating && manualCartPromoEntries(scope,scope._nnomManualCart).length) { setCartDiscountStatus(scope,'codeConflict','warning'); return; }
    if (button.matches('[data-nnom-cart-rewards-switch]')) button.dataset.nnomCartRewardsMode = isCartRewardsSelected(scope) ? 'off' : 'on';
    if (button.dataset.nnomCartRewardsMode === 'off') {
      disableCartRewards(scope);
    } else if (scope.dataset.reservationId) {
      setCartRewardsSelected(scope, true);
    } else {
      prepareCartRewards(scope).then(function (ready) {
        if (!ready || !scope.dataset.selectedVoucher) return;
        setCartRewardsBusy(scope, true);
        return updateCartAttributes({ 'NNOM Selected Voucher': '' }).then(function () {
          document.querySelectorAll('[data-nnom-cart-rewards]').forEach(function (other) {
            other.dataset.selectedVoucher = '';
            var select = other.querySelector('[data-nnom-benefit-select]');
            if (select) select.value = '';
            if (other !== scope) renderSelectedBenefitVoucher(other);
          });
        }).catch(function () {
          setCartRewardsSelected(scope, false);
          renderSelectedBenefitVoucher(scope);
          setCartRewardsStatus(scope, tr('chua_the_bo_voucher_da_chon_voucher_van_duoc_g_8da8f613',"Chưa thể bỏ voucher đã chọn. Voucher vẫn được giữ; hãy thử lại."), 'error');
        }).finally(function () { setCartRewardsBusy(scope, false); });
      });
    }
  }

  function selectBenefitVoucher(select) {
    if (manualDiscountBusy) return;
    var scope = select.closest('[data-nnom-cart-rewards]');
    if (!scope) return;
    var code = select.value;
    var previous = scope.dataset.selectedVoucher || '';
    if (code && !(scope._nnomBenefitVouchers || []).some(function (voucher) { return voucher.code === code; })) {
      select.value = previous;
      return;
    }
    setCartRewardsBusy(scope, true);
    disableCartRewards(scope).then(function (cancelled) {
      if (!cancelled) throw new Error(tr('chua_the_bo_voucher_xu_dang_giu_191246c9',"Chưa thể bỏ voucher Xu đang giữ."));
      setCartRewardsBusy(scope, true);
      return updateCartAttributes({ 'NNOM Selected Voucher': code });
    }).then(function () {
      document.querySelectorAll('[data-nnom-cart-rewards]').forEach(function (other) {
        other.dataset.selectedVoucher = code;
        var otherSelect = other.querySelector('[data-nnom-benefit-select]');
        if (otherSelect) otherSelect.value = code;
        renderSelectedBenefitVoucher(other);
      });
      setCartRewardsStatus(scope, code ? tr('ma_se_duoc_ap_dung_khi_thanh_toan_398dfc94',"Mã sẽ được áp dụng khi thanh toán.") : tr('da_bo_ma_khuyen_mai_f6f75f0a',"Đã bỏ mã khuyến mãi."), 'success');
    }).catch(function (error) {
      select.value = previous;
      renderSelectedBenefitVoucher(scope);
      setCartRewardsStatus(scope, error && error.message || tr('chua_the_cap_nhat_ma_khuyen_mai_05163f7a',"Chưa thể cập nhật mã khuyến mãi."), 'error');
    }).finally(function () { setCartRewardsBusy(scope, false); });
  }

  function checkoutWithBenefitVoucher(scope) {
    var code = scope.dataset.selectedVoucher;
    if (!code) return false;
    setCartRewardsBusy(scope, true);
    Promise.all([getWallet(true), fetch(cartStateUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(parseJson)]).then(function (values) {
      var wallet = values[0];
      var cart = values[1];
      var voucher = (wallet.vouchers || []).find(function (item) { return item.code === code; });
      if (!voucher) throw new Error(tr('ma_khuyen_mai_khong_con_hieu_luc_hay_chon_lai_be5323fc',"Mã khuyến mãi không còn hiệu lực. Hãy chọn lại."));
      if (Number(voucher.minimumSubtotalVnd || 0) > cartTotalVnd(cart)) throw new Error(tr('gio_hang_chua_dat_gia_tri_toi_thieu_cua_vouche_7c72bc30',"Giỏ hàng chưa đạt giá trị tối thiểu của voucher."));
      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout'));
    }).catch(function (error) {
      setCartRewardsStatus(scope, error && error.message || tr('chua_the_kiem_tra_ma_khuyen_mai_afbae800',"Chưa thể kiểm tra mã khuyến mãi."), 'error');
    }).finally(function () { setCartRewardsBusy(scope, false); });
    return true;
  }

  function submitVoucher(form) {
    var scope = form.closest('[data-nnom-rewards-portal]');
    var status = form.querySelector('[data-nnom-rewards-voucher-status]');
    var submit = form.querySelector('[type="submit"]');
    var amount = Math.floor(Number(form.elements.requestedLp.value));
    var max = Number(scope && scope.dataset.voucherMaxLp || 0);
    if (!Number.isInteger(amount) || amount <= 0) {
      status.textContent = tr('vui_long_nhap_gia_tri_voucher_hop_le_ef94cd5b',"Vui lòng nhập giá trị voucher hợp lệ.");
      status.dataset.tone = 'error';
      form.elements.requestedLp.focus();
      return;
    }
    if (max > 0 && amount > max) {
      status.textContent = tr('gia_tri_voucher_khong_duoc_vuot_qua_so_diem_kh_c8b0700a',"Giá trị voucher không được vượt quá số điểm khả dụng của bạn.");
      status.dataset.tone = 'error';
      form.elements.requestedLp.focus();
      return;
    }
    setButtonBusy(submit, true);
    status.textContent = tr('dang_giu_diem_va_tao_voucher_8acd7c44',"Đang giữ điểm và tạo voucher…");
    status.removeAttribute('data-tone');
    fetch(cartStateUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parseJson)
      .then(function (cart) {
        if (!cart.token) throw new Error(tr('khong_xac_dinh_duoc_gio_hang_vui_long_tai_lai__8308ae1e',"Không xác định được giỏ hàng. Vui lòng tải lại trang."));
        return request('/redeem', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ requestedLp: amount, cartToken: cart.token })
        });
      })
      .then(function (result) {
        if (result.ready && result.reservation && result.reservation.checkoutPath) return result;
        if (!result.reservation || !result.reservation.id) {
          throw new Error(tr('khong_the_tao_voucher_vui_long_thu_lai_c6f0ef38',"Không thể tạo voucher. Vui lòng thử lại."));
        }
        status.textContent = tr('voucher_dang_duoc_tao_5585a5b1',"Voucher đang được tạo…");
        return pollVoucher(result.reservation.id, 25);
      })
      .then(function (result) {
        status.textContent = tr('voucher_da_san_sang_dang_chuyen_den_thanh_toan_dc156861',"Voucher đã sẵn sàng. Đang chuyển đến thanh toán…");
        status.dataset.tone = 'success';
        window.location.assign(result.reservation.checkoutPath);
      })
      .catch(function (error) {
        status.textContent = error && error.message ? error.message : tr('khong_the_tao_voucher_vui_long_thu_lai_c6f0ef38',"Không thể tạo voucher. Vui lòng thử lại.");
        status.dataset.tone = 'error';
      })
      .finally(function () { setButtonBusy(submit, false); });
  }

  function applySelectedBenefitVouchers(scope, codes) {
    if (!scope) return;
    var keepDialogOpen = Boolean(scope.querySelector('[data-nnom-rewards-modal][open]'));
    var available = scope._nnomBenefitVouchers || [];
    codes = (codes || []).filter(function (code, index, list) {
      return list.indexOf(code) === index && available.some(function (voucher) { return voucher.code === code; });
    });
    codes = compatibleVoucherCodes(codes, available, scope.dataset.allowMultipleVouchers === 'true');
    setCartRewardsBusy(scope, true);
    var cancellation = scope.dataset.reservationId || isCartRewardsSelected(scope) ? disableCartRewards(scope) : Promise.resolve(true);
    cancellation.then(function (cancelled) {
      if (!cancelled) throw new Error('Could not release the held reward points.');
      return fetch(cartStateUrl(),{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(parseJson).then(function (cart) {
        var previous = readSelectedVoucherCodes(cart.attributes && (cart.attributes['NNOM Selected Vouchers'] || cart.attributes['NNOM Selected Voucher']) || scope.dataset.selectedVouchers || scope.dataset.selectedVoucher);
        var external = cartPromoEntries(cart).map(function (entry) { return entry.code; }).filter(function (code) { return !previous.some(function (old) { return old.toUpperCase() === code.toUpperCase(); }) && !available.some(function (voucher) { return voucher.code.toUpperCase() === code.toUpperCase(); }); });
        return updateCartDiscountCodes(codes.concat(external),undefined,{'NNOM Selected Vouchers':JSON.stringify(codes),'NNOM Selected Voucher':codes[0] || ''});
      });
    }).then(function (cart) {
      document.querySelectorAll('[data-nnom-cart-rewards]').forEach(function (other) {
        other.dataset.selectedVouchers = JSON.stringify(codes);
        other.dataset.selectedVoucher = codes[0] || '';
        var select = other.querySelector('[data-nnom-benefit-select]');
        if (select) select.value = codes[0] || '';
        other.querySelectorAll('[data-nnom-cart-voucher-code]').forEach(function (button) {
          var active = Boolean(button.dataset.nnomCartVoucherCode) && codes.includes(button.dataset.nnomCartVoucherCode);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (button.classList.contains('nnom-cart-rewards__voucher-pick')) button.textContent = active ? tr('da_chon_7f7e38b3',"Đã chọn") : tr('chon_ma_9e7c9e93',"Chọn mã");
        });
        renderSelectedBenefitVoucher(other, cart);
      });
      setCartRewardsStatus(scope, codes.length ? tr('da_gui_lua_chon_cho_shopify_so_giam_thuc_te_du_d68f6ba7',"Đã gửi lựa chọn cho Shopify. Số giảm thực tế được cập nhật trong giỏ.") : tr('da_bo_voucher_rewards_khoi_gio_d8bba826',"Đã bỏ voucher Rewards khỏi giỏ."), 'success');
      if (scope.dataset.nnomCartView === 'full') {
        window.location.reload();
        return;
      }
      return refreshCartDrawer(cart).then(function () {
        if (keepDialogOpen) {
          rewardsDialogShouldStayOpen = true;
          restoreRewardsDialog(8);
        }
      });
    }).catch(function (error) {
      setCartRewardsStatus(scope, error && error.message || 'Could not apply reward vouchers.', 'error');
    }).finally(function () { setCartRewardsBusy(scope, false); });
  }

  function toggleBenefitVoucher(button) {
    if (manualDiscountBusy) return;
    var scope = button.closest('[data-nnom-cart-rewards]');
    if (!scope || button.disabled || scope.getAttribute('aria-busy') === 'true') return;
    var code = button.dataset.nnomCartVoucherCode || '';
    var selected = readSelectedVoucherCodes(scope.dataset.selectedVouchers || scope.dataset.selectedVoucher || '');
    if (!code) selected = [];
    else if (scope.dataset.allowMultipleVouchers === 'true') {
      if (selected.includes(code)) selected = selected.filter(function (item) { return item !== code; });
      else {
        var vouchers = scope._nnomBenefitVouchers || [];
        var nextVoucher = vouchers.find(function (item) { return item.code === code; });
        var currentAllowsCombination = selected.every(function (itemCode) {
          var item = vouchers.find(function (voucher) { return voucher.code === itemCode; });
          return item && nextVoucher && vouchersCanCombine(item, nextVoucher);
        });
        selected = nextVoucher && currentAllowsCombination
          ? selected.concat(code) : [code];
      }
    } else selected = selected.includes(code) ? [] : [code];
    applySelectedBenefitVouchers(scope, selected);
  }

  document.addEventListener('change', function (event) {
    var benefitSelect = event.target.closest('[data-nnom-benefit-select]');
    if (benefitSelect) {
      selectBenefitVoucher(benefitSelect);
      return;
    }
    var select = event.target.closest('[data-nnom-rewards-depot]');
    if (select) handleDepotChange(select);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches('[data-nnom-discount-code]')) { event.preventDefault(); applyManualCartDiscount(event.target.closest('[data-nnom-cart-rewards]')); }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-nnom-discount-code]')) { manualDiscountNotice = null; setCartDiscountStatus(event.target.closest('[data-nnom-cart-rewards]'),''); }
    var pointsInput = event.target.closest('[name="nnom-cart-rewards-points"]');
    if (pointsInput) previewCartRewardDiscount(pointsInput.closest('[data-nnom-cart-rewards]'));
  });

  document.addEventListener('click', function (event) {
    var discountButton = event.target.closest('[data-nnom-discount-apply],[data-nnom-discount-remove]');
    if (discountButton) { event.preventDefault(); if (!discountButton.disabled) applyManualCartDiscount(discountButton.closest('[data-nnom-cart-rewards]'),discountButton.dataset.nnomDiscountRemove); return; }
    var rewardVoucherCard = event.target.closest('[data-nnom-cart-voucher-code]');
    if (rewardVoucherCard) {
      event.preventDefault();
      toggleBenefitVoucher(rewardVoucherCard);
      return;
    }

    var offerButton = event.target.closest('[data-nnom-voucher-offer-redeem]');
    if (offerButton) {
      event.preventDefault();
      redeemVoucherOffer(offerButton);
      return;
    }

    var cartVoucherButton = event.target.closest('[data-nnom-cart-voucher-code]');
    if (cartVoucherButton) {
      event.preventDefault();
      var voucherScope = cartVoucherButton.closest('[data-nnom-cart-rewards]');
      var voucherSelect = voucherScope && voucherScope.querySelector('[data-nnom-benefit-select]');
      if (voucherSelect && !cartVoucherButton.disabled) {
        voucherSelect.value = cartVoucherButton.dataset.nnomCartVoucherCode || '';
        voucherSelect.dispatchEvent(new Event('change', { bubbles: true }));
        voucherScope.querySelectorAll('[data-nnom-cart-voucher-code]').forEach(function (button) {
          var selected = button.dataset.nnomCartVoucherCode === voucherSelect.value;
          if (button.classList.contains('nnom-cart-rewards__voucher-pick')) {
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
            button.textContent = selected ? tr('da_chon_7f7e38b3',"Đã chọn") : tr('chon_ma_9e7c9e93',"Chọn mã");
          }
        });
      }
      return;
    }

    var rewardsModalOpen = event.target.closest('[data-nnom-rewards-modal-open]');
    if (rewardsModalOpen) {
      event.preventDefault();
      var rewardsModal = rewardsModalOpen.closest('[data-nnom-cart-rewards]').querySelector('[data-nnom-rewards-modal]');
      if (rewardsModal && !rewardsModal.open) {
        if (!rewardsModal._nnomEscapeBound) {
        rewardsModal.addEventListener('cancel', function (cancelEvent) {
          cancelEvent.preventDefault();
          rewardsDialogShouldStayOpen = false;
          rewardsModal.close();
          // Disabled apply buttons can move focus outside the dialog. Consume
          // the matching Escape keyup before the parent drawer handles it.
          window.addEventListener('keyup', function (keyEvent) { if (keyEvent.key === 'Escape') keyEvent.stopPropagation(); }, { capture: true, once: true });
        });
          rewardsModal.addEventListener('keyup', function (keyEvent) {
            if (keyEvent.key !== 'Escape') return;
            keyEvent.stopPropagation();
            rewardsDialogShouldStayOpen = false;
            rewardsModal.close();
          });
          rewardsModal._nnomEscapeBound = true;
        }
        rewardsModal.showModal();
        rewardsDialogShouldStayOpen = true;
      }
      return;
    }

    var rewardsModalClose = event.target.closest('[data-nnom-rewards-modal-close]');
    if (rewardsModalClose) {
      event.preventDefault();
      var openModal = rewardsModalClose.closest('[data-nnom-rewards-modal]');
      rewardsDialogShouldStayOpen = false;
      if (openModal && openModal.open) openModal.close();
      return;
    }

    if (event.target.matches('[data-nnom-rewards-modal]') && event.target.open) {
      rewardsDialogShouldStayOpen = false;
      event.target.close();
      return;
    }

    var cartRewardsToggle = event.target.closest('[data-nnom-cart-rewards-toggle], [data-nnom-cart-rewards-switch]');
    if (cartRewardsToggle) {
      event.preventDefault();
      handleCartRewardToggle(cartRewardsToggle);
      return;
    }

    var applyButton = event.target.closest('[data-nnom-rewards-apply]');
    if (applyButton) {
      event.preventDefault();
      applyRewards(applyButton);
      return;
    }

    var copyButton = event.target.closest('[data-nnom-rewards-copy]');
    if (copyButton) {
      event.preventDefault();
      copyInvite(copyButton);
    }
  });

  document.addEventListener('submit', function (event) {
    var checkoutForm = event.target.closest('#CartDrawer-Form, #cart');
    if (checkoutForm && manualDiscountBusy) { event.preventDefault(); return; }
    if (checkoutForm && event.submitter && event.submitter.name !== 'checkout') return;
    if (checkoutForm) {
      var cartRewards = checkoutForm.id === 'cart'
        ? document.querySelector('#main-cart-footer [data-nnom-cart-rewards]')
        : checkoutForm.closest('cart-drawer') && checkoutForm.closest('cart-drawer').querySelector('[data-nnom-cart-rewards]');
      if (isCartRewardsSelected(cartRewards)) {
        event.preventDefault();
        if (cartRewards.dataset.reservationId) {
          setCartRewardsBusy(cartRewards, true);
          request('/redeem?reservationId=' + encodeURIComponent(cartRewards.dataset.reservationId))
            .then(function (result) {
              if (result.ready && result.reservation && result.reservation.checkoutPath) return result;
              return pollVoucher(cartRewards.dataset.reservationId, 25);
            })
            .then(function (result) { window.location.assign(result.reservation.checkoutPath); })
            .catch(function (error) {
              setCartRewardsStatus(cartRewards, error && error.message ? error.message : tr('chua_the_dung_voucher_vui_long_thu_lai_fccaf9a1',"Chưa thể dùng voucher. Vui lòng thử lại."), 'error');
            })
            .finally(function () { setCartRewardsBusy(cartRewards, false); });
        } else {
          redeemCartRewards(cartRewards);
        }
        return;
      }
    }

    var form = event.target.closest('[data-nnom-rewards-voucher]');
    if (!form) return;
    event.preventDefault();
    submitVoucher(form);
  });

  document.addEventListener('DOMContentLoaded', function () {
    captureReferral();
    hydrateAll();
    restoreRewardsAfterSignIn();
    var rewardsSelector = '[data-nnom-rewards-cart], [data-nnom-rewards-portal], [data-nnom-cart-rewards]';
    var observer = new MutationObserver(function (mutations) {
      var rewardsAdded = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 &&
            (node.matches(rewardsSelector) || node.querySelector(rewardsSelector));
        });
      });
      if (rewardsAdded) {
        scheduleHydrate();
        if (rewardsDialogShouldStayOpen) restoreRewardsDialog(8);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    walletPromise = null;
    document.querySelectorAll('[data-nnom-cart-rewards]').forEach(resetCartRewardScope);
    scheduleHydrate();
  });
})();
